import { ValidatorFn, AbstractControl } from '@angular/forms';
/**
 * @return {?}
 */
export function NoLeadingMinValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (control.value.substring(0, 1) === '-') {
      return { noLeadingMin: { value: control.value } };
    }

    return null;
  };
}
